import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { BdoApiService } from '../bdo/services/bdo-api.service';
import { CustomerStoreService } from '../bdo/services/customer-store.service';
import { VEBOUTGUARD_PROCESS } from '../bdo/enums/vebOutGuardProcess.enum';

export function guardVebOut(vebOutGuardProcess: VEBOUTGUARD_PROCESS): CanActivateFn {
  return (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) => {
    const apiService = inject(BdoApiService);
    const customerStore = inject(CustomerStoreService);
    const router = inject(Router);
    const handleAccountId: () => Observable<string> = () => {
      let accountIdObs$: Observable<string>;
      if (customerStore.getAccountId()) {
        accountIdObs$ = of(customerStore.getAccountId());
      } else {
        // getAccounts
        accountIdObs$ = apiService.getAccounts().pipe(switchMap((accounts) => {
          const accountId = accounts.filter((account) => !account.inaktiv)?.[0]?.accountId;
          customerStore.setAccountId(accountId);
          return of(accountId);
        }), catchError((err: unknown) => {
          return of('');
        }));
      }
      return accountIdObs$;
    };

    // Anonymous access is no longer possible (the route is protected by guardAuth),
    // so only the logged-in flow is handled here.
    return handleAccountId().pipe(
      switchMap((accountId) => {
        return apiService.getZaehlerIdentifiers().pipe(
          map(identifiers => {
            const activeMeters = identifiers?.filter(identifier => !identifier.inaktiv);
            return { accountId, meterNumber: activeMeters[0]?.meterNumber };
          }));
      }),
      switchMap(({ accountId, meterNumber }) => {
        // For Cancel singular divisions can be cancelled, so we check if there is an active meter left to be cancelled
        // TODO: Check this behaviour when we (re)introduce logged-in cancel process
        return apiService.getMoveOut(accountId, meterNumber, vebOutGuardProcess === VEBOUTGUARD_PROCESS.CANCEL);
      }),
      switchMap((moveOutResponse) => {
        const hasVebOut: boolean = JSON.parse(moveOutResponse.info?.toLowerCase());
        if (hasVebOut) {
          return of(router.parseUrl('/hinweis-auszug'));
        } else {
          return of(true);
        }
      })
      , catchError((err: unknown) => {
          return of(true);
        }
      )
    );
  };
}

